const getScope = actionIndex => `send-ai-process-results-${actionIndex}`;

export const LoanActionSendAiProcessResultsRowTestIds = {
  getProcessSelectId: actionIndex => `${getScope(actionIndex)}.process-select`,
  getConnectorSelectId: actionIndex => `${getScope(actionIndex)}.connector-select`,
  getTagSelectId: (actionIndex, tagKey) => `${getScope(actionIndex)}.${tagKey}-select`,
};
